const language = {
    'pt': 
        {
            add_new:            'Adicionar novo',
            cancel:             'Cancelar', back: 'Voltar',
            category:           'Categoria',
            category_new:       'Nova categoria',
            category_edit:      'Editar categoria',
            category_list:      'Lista de categorias',
            close:              'Fechar',
            color:              'Cor',
            color_placeholder:  'Introduza a cor',
            delete:             'Eliminar',
            delete_title:       'Eliminar Registo',
            delete_text:        'Tem a certeza que pretende continuar?',
            delete_confirm:     'Sim',
            delete_cancel:      'Não',
            delete_error:       'Problema ao apagar registo!',
            delete_success:     'Registo apagado com sucesso!',
            edit:               'Editar',
            edit_title:         'Editar Registo',
            edit_text:          'Tem a certeza que pretende continuar?',
            edit_confirm:       'Sim',
            edit_cancel:        'Não',
            edit_error:         'Problema ao actualizar registo!',
            edit_success:       'Registo actualizado com sucesso!',
            filter_placeholder: 'Procurar',
            id:                 'ID',
            name:               'Nome',
            name_placeholder:   'Introduza o nome',
            insert_title:       'Novo Registo',
            insert_text:        'Tem a certeza que pretende continuar?',
            insert_confirm:     'Sim',
            insert_cancel:      'Não',
            insert_error:       'Problema ao inserir registo!',
            insert_success:     'Registo inserido com sucesso!',
            principal:          'Principal',
            remove:             'Remover',
            table_rows_per_page:'Registos por página:',
            table_separator:    'de',
            table_all:          'Todos',
            table_title:        'Título',
            table_parent:       'Parent',
            table_date:         'Data',
            table_state:        'Estado',
            table_actions:      'Acções',
            table_empty:        'sem resultados',
            save:               'Salvar',                  
        },
    'en':
        {
            add_new:            'Add new',
            calendar:           'Calendar',
            cancel:             'Cancel', back: 'Voltar',
            category:           'Category',
            category_new:       'New category',
            category_edit:      'Editar category',
            category_list:      'List of categories',
            close:              'Close',
            color:              'Color',
            color_placeholder:  'Insert the color',
            delete:             'Delete',
            delete_title:       'Delete Regist',
            delete_text:        'Are you sure you want to continue?',
            delete_confirm:     'Yes',
            delete_cancel:      'No',
            delete_error:       'Problem deleting the element!',
            delete_success:     'Element deleted successfully!',
            edit:               'Edit',
            edit_title:         'Edit Regist',
            edit_text:          'Are you sure you want to continue?',
            edit_confirm:       'Yes',
            edit_cancel:        'No',
            edit_error:         'Problem updating element!',
            edit_success:       'Successful updated element!',
            id:                 'ID',
            name:               'Name',
            name_placeholder:   'Insert the name',
            insert_title:       'New Regist',
            insert_text:        'Are you sure you want to continue?',
            insert_confirm:     'Yes',
            insert_cancel:      'No',
            insert_error:       'Problem updating element!',
            insert_success:     'Successful updated element!',
            principal:          'Principal',
            remove:             'Remove',
            table_rows_per_page:'Regist by page:',
            table_separator:    'of',
            table_all:          'All',
            table_title:        'Title',
            table_parent:       'Parent',
            table_date:         'Date',
            table_state:        'State',
            table_actions:      'Actions',
            table_empty:        'no results',
            save:               'Save',
        },
        'es':
        {
            add_new: 'Agregar nuevo',
cancel: 'Cancelar', back: 'Voltar',
category: 'Categoría',
category_new: 'Nueva categoría',
category_edit: 'Editar categoría',
category_list: 'Lista de categorías',
close: 'Cerrar',
color: 'Color',
color_placeholder: 'Introduce el color',
delete: 'Eliminar',
delete_title: 'Eliminar registro',
delete_text: '¿Está seguro de que desea continuar?',
delete_confirm: 'Sí',
delete_cancel: 'No',
delete_error: '¡Error al eliminar registro!',
delete_success: '¡Registro eliminado con éxito!',
edit: 'Editar',
edit_title: 'Editar registro',
edit_text: '¿Está seguro de que desea continuar?',
edit_confirm: 'Sí',
edit_cancel: 'No',
edit_error: '¡Error al actualizar registro!',
edit_success: '¡Registro actualizado con éxito!',
filter_placeholder: 'Buscar',
id: 'ID',
name: 'Nombre',
name_placeholder: 'Introduce el nombre',
insert_title: 'Nuevo registro',
insert_text: '¿Está seguro de que desea continuar?',
insert_confirm: 'Sí',
insert_cancel: 'No',
insert_error: '¡Error al insertar registro!',
insert_success: '¡Registro insertado con éxito!',
principal: 'Principal',
remove: 'Eliminar',
table_rows_per_page: 'Registros por página:',
table_separator: 'de',
table_all: 'Todos',
table_title: 'Título',
table_parent: 'Parent',
table_date: 'Fecha',
table_state: 'Estado',
table_actions: 'Acciones',
table_empty: 'sin resultados',
save: 'Guardar',

        },
        'fr':{
            add_new: 'Ajouter nouveau',
cancel: 'Annuler',
category: 'Catégorie',
category_new: 'Nouvelle catégorie',
category_edit: 'Modifier la catégorie',
category_list: 'Liste des catégories',
close: 'Fermer',
color: 'Couleur',
color_placeholder: 'Entrez la couleur',
delete: 'Supprimer',
delete_title: 'Supprimer l’enregistrement',
delete_text: 'Êtes-vous sûr de vouloir continuer ?',
delete_confirm: 'Oui',
delete_cancel: 'Non',
delete_error: 'Erreur lors de la suppression de l’enregistrement !',
delete_success: 'Enregistrement supprimé avec succès !',
edit: 'Modifier',
edit_title: 'Modifier l’enregistrement',
edit_text: 'Êtes-vous sûr de vouloir continuer ?',
edit_confirm: 'Oui',
edit_cancel: 'Non',
edit_error: 'Erreur lors de la mise à jour de l’enregistrement !',
edit_success: 'Enregistrement mis à jour avec succès !',
filter_placeholder: 'Rechercher',
id: 'ID',
name: 'Nom',
name_placeholder: 'Entrez le nom',
insert_title: 'Nouvel enregistrement',
insert_text: 'Êtes-vous sûr de vouloir continuer ?',
insert_confirm: 'Oui',
insert_cancel: 'Non',
insert_error: 'Erreur lors de l’insertion de l’enregistrement !',
insert_success: 'Enregistrement inséré avec succès !',
principal: 'Principal',
remove: 'Retirer',
table_rows_per_page: 'Enregistrements par page :',
table_separator: 'de',
table_all: 'Tous',
table_title: 'Titre',
table_parent: 'Parent',
table_date: 'Date',
table_state: 'État',
table_actions: 'Actions',
table_empty: 'aucun résultat',
save: 'Enregistrer',

        },
}

module.exports = {
    language
};